/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
 */
import mergeProps from "@/router/utils/mergeProps";

let UpcomingSessionsView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/ScheduledEvents/UpcomingSessionsView')
let PastSessionsView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/ScheduledEvents/PastSessionsView')

let EventTypesView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/EventTypes/EventTypesView')
let ScheduledEventsView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/ScheduledEvents/ScheduledEventsView')
let CalendarIntegrationsMainView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/CalendarIntegrations/CalendarIntegrationsMainView')
let AvailabilitySettingsView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/Availability/AvailabilitySettingsView')

let SchedulerMainView = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/SchedulerMainView')
let SchedulerWizard = () => import(/* webpackChunkName: "CoachScheduler" */ '@/core/modules/coach/Scheduler/SetupWizard/SchedulerWizard')
let EmptyRouterView = () => import(/* webpackChunkName: "Login" */ '@/core/components/EmptyRouterView.vue')

import eventTypeSettingsRoutesFn from './eventTypeSettingsRoutesFn'
import redirectByName from "@/router/utils/redirectByName.js";


export default function (basePath = "") {
	let schedulerWizard = basePath + "SchedulerWizard"

	let schedulerMain = basePath + "SchedulerMain"
	let sessionsMain = basePath + "SessionsMain"
	let schedulerSessions = basePath + "SchedulerSessions"
	let schedulerCoach = basePath + "SchedulerCoach"
	let schedulerGeneralAvailability = basePath + "SchedulerGeneralAvailability"
	let schedulerTypes = basePath + "SchedulerTypes"

	let eventTypeSettingsMainRouteName = basePath + "EventTypeRoot"

	console.log("schedulerRoutes: basePath = ",basePath)

	return [


		{
			path: 'scheduler',
			meta:{
				schedulerMainRoute: schedulerMain,
				sessionsMainRoute: sessionsMain,
				schedulerCoachRoute: schedulerCoach,
				schedulerWizardRoute: schedulerWizard,
				eventTypeRootRoute: eventTypeSettingsMainRouteName,
			},
			redirect: redirectByName(schedulerMain),
			component: EmptyRouterView,
			props: mergeProps,
			children: [
				{
					path: 'setup',
					name: schedulerWizard,
					props: route => ({
						responseParam: route.query.res,
						schedulerWizardRoute: schedulerWizard,
						schedulerCoachRoute: schedulerCoach
					}),
					component: SchedulerWizard,
				},
				{
					path: 'types',
					// name: schedulerTypes,
					component: EmptyRouterView,
					redirect: redirectByName(schedulerMain),
					props: mergeProps,
					children:[
						...eventTypeSettingsRoutesFn({
							mainRouteName: eventTypeSettingsMainRouteName,
							backRouteName: schedulerMain,
							schedulerGeneralAvailabilityRoute: schedulerGeneralAvailability
						}, )
					],

				},

				{
					path: '',
					name: schedulerMain,
					redirect: redirectByName(schedulerCoach, {activeTab: 'types'}),
					component: SchedulerMainView,
					props: mergeProps,


					children: [
						{
							path: 'sessions',
							name: sessionsMain,
							redirect: redirectByName(schedulerSessions, {sessionActiveTab: 'upcoming'}),
							components: {
								sessions: ScheduledEventsView
							},
							props: mergeProps,
							meta:{
								activeTab: 'sessions',
								sessionsMainRoute: sessionsMain,
								schedulerSessionsRoute: schedulerSessions,
								schedulerCoachRoute: schedulerCoach
							},
							children: [
								{
									path: ':sessionActiveTab',
									name: schedulerSessions,
									props: mergeProps,
									components: {
										upcoming: UpcomingSessionsView,
										past: PastSessionsView,
									},
								},

							]
						},


						{
							path: ':activeTab',
							name: schedulerCoach,
							props: true,
							meta: {
								eventTypeRootRoute: eventTypeSettingsMainRouteName,
							},
							components: {
								// sessions: ScheduledEventsView,
								types: EventTypesView,
								availability: AvailabilitySettingsView,
								calendars: CalendarIntegrationsMainView
							},
						},

						{
							path: '/nonemptypath',
							redirect: redirectByName(schedulerCoach, {activeTab: "availability"}),
							name: schedulerGeneralAvailability
						},

					]
				},



			]
		},

		// {
		// 	path: 'scheduler',
		// 	redirect: redirectByName(schedulerTypes),//'scheduler/types',
		// },

	]
}


